import React from 'react';
import { Menu, Search } from 'lucide-react';

interface HeaderProps {
  onMenuClick: () => void;
  onSearchClick: () => void;
}

export function Header({ onMenuClick, onSearchClick }: HeaderProps) {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between p-4 bg-black/80 backdrop-blur-md border-b border-gray-800/60 safe-area-top h-16">
      <button
        onClick={onMenuClick}
        className="bg-gray-800/50 p-2 rounded-full"
      >
        <Menu className="w-5 h-5 text-white" />
      </button>
      <span className="text-white font-bold text-xl tracking-tight absolute left-1/2 -translate-x-1/2 font-poppins animate-echo-intro">
        ECHO
      </span>
      <button
        onClick={onSearchClick}
        className="bg-gray-800/50 p-2 rounded-full"
      >
        <Search className="w-5 h-5 text-white" />
      </button>
    </div>
  );
}